import { StrippedHTMLFreeRenderer } from '../../../../utils/strippedHtml';
import { CommentTypeRenderer } from '../../../../utils/commentType';
import { ClickableCellRenderer } from '../../../AGGrid/cell-renderers/clickable';
import { IconCellRenderer } from '../../../AGGrid/cell-renderers/icon';
import {CustomHeader} from "../../../AGGrid/cell-renderers/custom-header";

export const id = {
    field: 'id',
    headerName: 'ID',
    cellRenderer: 'agGroupCellRenderer',
    width: 100,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'comments'
    }
};

export const productId = {
    field: 'productId',
    headerName: 'Product ID',
    width: 100,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productId',
        page: 'comments'
    }
};

export const financialTitleId = {
    field: 'foxFinancialTitleId',
    headerName: 'Financial Title ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'foxFinancialTitleId',
        page: 'comments'
    }
};

export const title = {
    field: 'title',
    headerName: 'Title',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'title',
        page: 'comments'
    }
};

export const commentPreview = {
    field: 'body',
    headerName: 'Comment Preview',
    width: 500,
    wrapText: true,
    cellRenderer: (params) => StrippedHTMLFreeRenderer(params),
};

export const type = {
    field: 'commentType',
    headerName: 'Type',
    width: 200,
    wrapText: true,
    cellRenderer: (params) => CommentTypeRenderer(params),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'commentType',
        page: 'comments'
    }
};

export const isPublic = {
    headerName: 'Is Public',
    cellRenderer: IconCellRenderer(),
    width: 100,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'isPublic',
        page: 'comments'
    }
};

export const attachments = (onOpenAttachmentsModal) => ({
    field: 'attachments.length',
    headerName: 'Attachments',
    width: 125,
    cellRenderer: ClickableCellRenderer(onOpenAttachmentsModal, 'fa-paperclip'),
});

export const commenter = {
    field: 'createdBy.username',
    headerName: 'Commenter',
    width: 150,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdBy.username',
        page: 'comments'
    }
};

export const commented = {
    field: 'createdAt',
    headerName: 'Commented',
    width: 150,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'comments'
    }
};
